import { cn } from '../../lib/format.js'

const VARIANTS = {
  primary:
    'bg-primary-500 text-ink-dark hover:bg-primary-400 active:bg-primary-600 shadow-[0_10px_30px_-14px_rgb(242_128_13/0.9)]',
  secondary: 'bg-surface-2 text-ink ring-1 ring-inset ring-white/10 hover:bg-white/10',
  ghost: 'text-ink-muted hover:text-ink hover:bg-white/5',
  accent: 'tint-fill hover:brightness-110',
  danger: 'bg-red-700 text-white hover:bg-red-800',
  discord: 'bg-discord text-white hover:bg-[#4752c4]',
  // Apple's sign-in button guidelines: white with black text on a dark page.
  apple: 'bg-white text-black hover:bg-white/90',
}

const SIZES = {
  sm: 'h-8 px-3 text-sm gap-1.5 rounded-lg',
  md: 'h-10 px-4 text-sm gap-2 rounded-xl',
  lg: 'h-12 px-6 text-base gap-2 rounded-xl',
  icon: 'size-10 rounded-xl',
}

export function buttonClasses({ variant = 'primary', size = 'md', className } = {}) {
  return cn(
    'inline-flex shrink-0 items-center justify-center font-medium whitespace-nowrap select-none transition-[background-color,color,filter,box-shadow] duration-150',
    'disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50',
    VARIANTS[variant],
    SIZES[size],
    className,
  )
}

// Renders a <button> by default, or any component passed as `as` (e.g. Link).
export function Button({ as: Component = 'button', variant, size, className, type, ...props }) {
  const extra = Component === 'button' ? { type: type ?? 'button' } : {}
  return <Component className={buttonClasses({ variant, size, className })} {...extra} {...props} />
}
